import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { union_type, class_type, record_type, bool_type, obj_type, lambda_type, unit_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Dashboard_DokumentenDepot, Dashboard_ToggleNotificationRequest_$reflection, Dashboard_ToggleNotificationRequest, Dashboard_DokumentenDepot_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Page } from "../DokumentenDepot/Types.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import * as react from "react";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_2 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { navigationArrow, bfsTile } from "../Shared/Tile.fs.js";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";

export class Model extends Record {
    constructor(GlobalDispatch, NavigateTo, Loading, Data) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.Loading = Loading;
        this.Data = Data;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.DokumentenDepot.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["Loading", bool_type], ["Data", Dashboard_DokumentenDepot_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "NavigateToList"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.DokumentenDepot.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_DokumentenDepot_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Dashboard_DokumentenDepot_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], []]);
}

export function Http_loadFiles() {
    const response = fetch("/api/dashboard/dokumentendepot", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_DokumentenDepot_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_setNotificationForNeueDokumente(enabled) {
    const payload = new Dashboard_ToggleNotificationRequest(enabled);
    return sendJson("/api/dashboard/set-notification-for-neue-dokumente", toString(0, Auto_generateBoxedEncoder_437914C6(Dashboard_ToggleNotificationRequest_$reflection(), undefined, undefined, undefined)(payload)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function State_init(props) {
    return [new Model(props.GlobalDispatch, props.NavigateTo, true, new Dashboard_DokumentenDepot(0, 0, 0, undefined)), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Daten für das Dokumentendepot können zur Zeit leider nicht geladen werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, msg.fields[0].fields[0]), Cmd_none()];
            }
        case 2: {
            model.NavigateTo(new Page());
            return [model, Cmd_none()];
        }
        default:
            return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data), request(Http_loadFiles, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export function renderItem(description, secondLine, value, isDark) {
    const color = isDark ? "is-dark" : "is-light";
    const children_6 = [react.createElement("div", {
        className: `tag is-rounded ${color} is-size-6 has-text-weight-bold`,
    }, value), react.createElement("div", {
        className: "is-size-7 has-text-grey-light has-text-centered",
    }, description), react.createElement("div", {
        className: "is-size-7 has-text-grey-light has-text-centered",
    }, secondLine)];
    return react.createElement("div", {
        className: "item",
    }, ...children_6);
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\DokumentenDepot.fs") + "#L") + int32ToString(value_2(92))) + ";") + "Dashboard.Shared.DashboardProps", value_2("View"), (props) => {
    let ruecksendung, matchValue_1, children_2;
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    return bfsTile("Dokumenten Depot", react.createElement("a", {
        onClick: (_arg_2) => {
            patternInput[1](new Msg(2, []));
        },
    }, navigationArrow), undefined, model_1.Loading ? spinner : ((ruecksendung = ((matchValue_1 = model_1.Data.NaechsteRuecksendung, (matchValue_1 != null) ? asString(matchValue_1) : "-")), (children_2 = [renderItem("Absetzungen", "", int32ToString(model_1.Data.Absetzungen), false), renderItem("Einlagerungen", "", int32ToString(model_1.Data.Einlagerungen), false), renderItem("Nicht angekaufte", "Rechnungen", int32ToString(model_1.Data.NichtAnkaeufe), false), renderItem("Nächste", "Rückssendung", ruecksendung, true)], react.createElement("div", {
        className: "dokumentendepot",
    }, ...children_2)))), undefined);
}, undefined, undefined, "Of");

//# sourceMappingURL=DokumentenDepot.fs.js.map
